import type { ReactNode } from 'react'

import { createContext, useContext, useState } from 'react'

type CurrencyScopeValue = readonly [string | null, (currency: string) => void]

const noop = () => undefined

// Outside a provider: no selection, setter is a no-op (falls back to backend default)
const CurrencyScopeContext = createContext<CurrencyScopeValue>([null, noop])

/** Owns the selected currency for one view; siblings stay independent. */
export const CurrencyScopeProvider = ({
	children,
}: {
	children: ReactNode
}) => {
	const [currency, setCurrency] = useState<string | null>(null)

	return (
		<CurrencyScopeContext.Provider value={[currency, setCurrency]}>
			{children}
		</CurrencyScopeContext.Provider>
	)
}

export const useCurrencyScope = () => useContext(CurrencyScopeContext)
